// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","ArrowHeight":"30px","arrow":"G337e53","arrow--top":"Gaa5509","arrow--bottom":"G6c8cba","arrow--left":"G1d69bf","arrow--right":"Gbf12fe"};